/* eslint-disable func-call-spacing,prefer-promise-reject-errors */
import axios from 'axios'
import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);
const instance = axios.create({
  baseURL: '',
  withCredentials: true, // 跨域类型时是否在请求中协带cookie
  timeout: 25 * 1000, // 请求超时时间
})
export default class HttpUtil {
  static get(url, params = {}) {
    return new Promise((resolve, reject) => {
      instance.get(url, { params }).then(({ data }) => {
        resolve(data)
      }).catch((err) => {
        Toast.fail({
          message: "请求超时！",
          className: "toastIndex"
        });
        //reject({ err: JSON.stringify(err) })
      })
    })
  }
  static post(url, params = {}) {
    return new Promise((resolve, reject) => {
      instance.post(url, params ).then(({ data }) => {
        resolve(data)
      }).catch((err) => {
        reject({ err: JSON.stringify(err) })
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/http/http.js